import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_photo_update",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "photo_update",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_photo_update_button",
  "data-kt-drawer-close": "#kt_drawer_photo_update_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_photo_update",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_photo_update_header\"><h2 class=\"fw-bolder text-light my-auto\">Trainee Photo Update</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_photo_update_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_photo_update_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_photo_update_body",
  "data-kt-scroll-dependencies": "#kt_photo_update_header, #kt_photo_update_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_photo_update_scroll"
}
const _hoisted_8 = { class: "col-md-12 mt-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload From Local Machine", -1)
const _hoisted_10 = { id: "preview" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "card-footer py-5 text-center",
  id: "kt_photo_update_footer"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_photo_update_close",
  class: "btn btn-danger me-5"
}, " Close ", -1)
const _hoisted_15 = ["data-kt-indicator"]
const _hoisted_16 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_17 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_18 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainee.photo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.photo) = $event)),
                      name: "photo",
                      ref: "traineeFileInput",
                      onChange: _ctx.traineePhoto,
                      type: "file",
                      class: "form-control"
                    }, null, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.url
                          }, null, 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: 
                        this.trainee?.attach_file_info?.file_path
                          ? _ctx.api_url + this.trainee?.attach_file_info?.file_path
                          : 'media/avatars/blank.png'
                      
                          }, null, 8, _hoisted_12))
                    ]),
                    _createVNode(_component_ErrorMessage, {
                      name: "trainee_image",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_17, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_19
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_15)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}